import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "categories-box" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "categories-filter" }
const _hoisted_4 = { class: "categories-filter__list categories-filter__list--desktop" }

import { DocsTagsView } from '@/models/docs.tags'
import CategoryItem from './CategoryItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesSelection',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.view.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.tags, (tag, index) => {
          return (_openBlock(), _createBlock(CategoryItem, {
            key: tag,
            tag: tag,
            view: __props.view,
            itemIndex: index
          }, null, 8, ["tag", "view", "itemIndex"]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(__props.view.mobileClass)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.view.tags, (tag) => {
          return (_openBlock(), _createBlock(CategoryItem, {
            key: tag,
            tag: tag,
            view: __props.view,
            isMobile: true
          }, null, 8, ["tag", "view"]))
        }), 128))
      ], 2),
      (__props.view.tags.length > 6 && !__props.view.showAllTags)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "categories-filter__btn categories-filter__btn--show",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.view.toggleShowAllTags && __props.view.toggleShowAllTags(...args)))
          }, " Show all categories "))
        : (__props.view.tags.length > 6)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "categories-filter__btn categories-filter__btn--hide",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.view.toggleShowAllTags && __props.view.toggleShowAllTags(...args)))
            }, " Hide categories "))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})